import * as types from 'actions';

export const initialState={
  adminId: '',
  adminName: '',
  adminDistrict: '',
  secondaryDistricts: [],
  adminStateLocation: '',
  adminCountry: '',
  isSignedIn: false,
  isSuperAdmin: false,
  isStateAdmin: false,
  redirectAfterSignInTo: undefined,
  userToken: '',
  roles: []
}

export default function(state = initialState, action) {
  const response = action.response;

  switch(action.type) {
    case types.LOGIN_USER_SUCCESS:        
      return {...state, 
        isSignedIn : true, 
        adminId: response.id,
        adminName : response.username,
        adminDistrict: response.district,
        secondaryDistricts: response.secondaryDistricts,
        adminStateLocation: response.stateLocation,
        adminCountry: response.country,
        roles: response.roles,
        isSuperAdmin: response.roles ? response.roles.includes('ROLE_SUPER_ADMIN') : false,
        isStateAdmin: response.roles ? response.roles.includes('ROLE_STATE_ADMIN') : false,
        response };
    case types.LOGIN_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
};